<template>
  <div class="box12-page">
    <pageTitle
      title="精品课程推荐"
    />
    <div class="course-box" ref="content">
      <div class="content-box">
        <img
          v-for="(item, index) in imgUrlList"
          :key="index"
          :src="item.img"
          alt=""
          @click="provideIndex(index)"
        />
      </div>
    </div>
    
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
  export default {
    name: '',
    components: {
      pageTitle,
    },
    data() {
      return {
        pageName: "newMedia2专题页H5",
        imgUrlList: [
          {
            lessonName:"51招打造爆款标题：短视频引爆攻略，快速起号涨粉",
            img: require("../../../assets/coursePage/newMedia2/box12/1.png"),
            url: "https://m.boxuegu.com/course/detail-5628",
            id: 1,
          },
          {
            lessonName:"短视频前3秒设计50招：吸睛利器，迅速吸引用户注意力",
            img: require("../../../assets/coursePage/newMedia2/box12/2.png"),
            url: "https://m.boxuegu.com/course/detail-5629",
            id: 2,
          },
          {
            lessonName:"释放文案魔力40招：揭示短视频流量密码，引爆创作能量",
            img: require("../../../assets/coursePage/newMedia2/box12/3.png"),
            url: "https://m.boxuegu.com/course/detail-5630",
            id: 3,
          },
        ],
      }
    },
    methods: {
      provideIndex(index) {
        this.mai(this.pageName,this.imgUrlList[index].lessonName,1,null)
        window.open(this.imgUrlList[index].url);
      }
    },
  }
</script>

<style lang="scss" scoped>
.box12-page {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/newMedia2/box12/bgc.png") no-repeat;
  background-size: cover;
}
.course-box {
  overflow-x: auto;
  padding-top: 50px;
  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .content-box {
    display: flex;
    align-items: center;
    img {
      width: 380px;
      height: 231px;
      border-radius: 14px;
      margin: 0 15px;
    }
  }
}
</style>